import { APIClient, AccessTokenInput } from '../api/APIClient';
import { Endpoints } from '../api/services';
import { AuthMode } from '../api/WPSClient';
import { InitialArgs, RequestContext } from '../types/request-context';

const mockedRequestContext: RequestContext = {
    domain: 'Retail',
    isInternal: '1',
    requestID: '61SMZFFAVAMGCXM7PCJD',
    sessionID: '260-0254514-1436644',
    customerID: '111111',
    marketplaceID: 'A3K6Y4MI8GDYMT',
    customerIPAddress: 'localhost',
    locale: 'en_US',
    osLocale: 'en_US',
    currentTerritory: 'CH',
    recordTerritory: 'DE',
    originalURI: 'originalURI',
    path: 'path',
    weblabOverrides: {
    },
    parameters: {},
    userAgent: 'userAgent',
    trafficPolicies: 'trafficPolicies',
    appName: 'appName',
    geoToken: 'geoToken',
    contingencies: null
};

export const mockedRequest: InitialArgs = {
    context: mockedRequestContext,
};

export const mockLogger = {
    debug() { return this },
    info() { return this },
    warn() { return this },
    error() { return this },
    fatal() { return this },
    cxfatal() { return this },
    count() { return this },
};

const mockEndpoints: Endpoints = new Proxy(({} as any), { get: (_, prop: string) => `https://${prop.toUpperCase()}` });

const widgetTimeout = 1000;

const mockedAuthentication = {
    authMode: AuthMode.ON,
    cloudauthClient: {
        getAccessToken(_: AccessTokenInput) {
            return Promise.resolve({
                tokenType: 'Bearer',
                token: 'access-token-content',
            });
        },
    },
};

export const mockApi = new APIClient(mockLogger, mockEndpoints, widgetTimeout, mockedAuthentication);
